import { render, staticRenderFns } from "./FormConsultaPendencias.vue?vue&type=template&id=6bf7e948&scoped=true"
import script from "./FormConsultaPendencias.vue?vue&type=script&lang=js"
export * from "./FormConsultaPendencias.vue?vue&type=script&lang=js"
import style0 from "./FormConsultaPendencias.vue?vue&type=style&index=0&id=6bf7e948&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6bf7e948",
  null
  
)

export default component.exports